import * as React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ROUTES } from 'consts';
import { useParamValues } from 'hooks/url.hook';
import { BuildingDetailsLayout } from 'layouts';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

export const BuildingDetailsNavigator = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const { buildingId } = useParamValues(['buildingId']);

  const invalidBuildingId = Number.isNaN(Number(buildingId));

  React.useEffect(() => {
    if (
      location.pathname.replace(`/${orgSlug}/`, '').replace(`${buildingId}`, ':buildingId') === ROUTES.BUILDING_DETAILS
    ) {
      navigate(ROUTES.ZONES_ACTIVE);
    }
  }, [location.pathname]);

  React.useEffect(() => {
    if (invalidBuildingId) {
      navigate(`/${orgSlug}/${ROUTES.BUILDINGS}`);
    }
  }, [invalidBuildingId]);

  return invalidBuildingId ? null : (
    <BuildingDetailsLayout>
      <Outlet />
    </BuildingDetailsLayout>
  );
};
